export default {
    methods: {
        calcConsum(current, prev, scale, bit) {
            if (current && current.toString().length > 0) {
                let curr = parseFloat(current);
                let consum = (curr < prev) ? (Math.pow(10, scale) - 1) - prev + curr : curr - prev
                return Math.trunc(consum*Math.pow(10, bit))/Math.pow(10, bit);
            }
            return 0;
        },
        createSubtitle(counter) {
            let arr = []
            if (counter.serialNumber) {
                arr.push(counter.serialNumber)
            }
            if (counter.location) {
                arr.push(counter.location)
            }
            return arr.join(', ')
        }
    }
}